import { useQuery } from '@tanstack/react-query';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';

import FormUserByRoleCollector from 'commons/FormUserByRoleCollector';
import API from 'configs/API';
import Section from 'features/Certificate/Section';
import useDebounce from 'hooks/useDebounce';

import useStyles from './styles';

const SelectUserCustomRequestCer = ({ artworkFormState, requestUser }) => {
  const { t } = useTranslation();
  const classes = useStyles();
  const user = useSelector((state) => state.auth.account.user);

  const { setValue, watch } = artworkFormState;
  const { inputSearchUser, linked_artwork } = watch();
  const inputSearchUserDebounce = useDebounce(inputSearchUser);

  const isArtistSelectedFromArtwork = !!linked_artwork?.artist;

  useEffect(() => {
    if (isArtistSelectedFromArtwork) {
      setValue('selectedUser', linked_artwork.artist, { shouldValidate: true });
    }
  }, [isArtistSelectedFromArtwork, linked_artwork?.artist, setValue]);

  const { data: userFilter = [] } = useQuery({
    queryKey: [API.AUTH.SEARCH_USER, { search: inputSearchUserDebounce, exclude__in: user?.id }],
    enabled: !isArtistSelectedFromArtwork,
  });

  const handleClickPaper = () => () => {};

  const handleInputSearchUser = (e) => {
    const value = e?.target?.value || '';
    setValue('inputSearchUser', value);
  };

  const handleCheckArtist = (e) => {
    const checked = e.target.checked;
    if (checked) {
      handleClearData();
    }
  };

  const handleClearData = () => {
    setValue('selectedUser', null, { shouldValidate: true });
    setValue('inputSearchUser', '');
  };

  const handleSelectUser = (e, newValue) => {
    setValue('selectedUser', newValue || null, { shouldValidate: true });
  };

  const handleSearchAgain = () => {
    setValue('selectedUser', null, { shouldValidate: true });
    setValue('inputSearchUser', '');
  };

  const handleClearIcon = () => {
    if (requestUser || isArtistSelectedFromArtwork) {
      return;
    }

    handleSearchAgain();
  };

  return (
    <Section
      title={t('request_to')}
      required
      wrapperStyle={classes.wrapper}
    >
      <div className={classes.wrapFormUser}>
        <FormUserByRoleCollector
          artworkFormState={artworkFormState}
          titleListUser={t('active_users')}
          userFilter={userFilter}
          handleCheckArtist={handleCheckArtist}
          handleInputSearchUser={handleInputSearchUser}
          handleClickPaper={handleClickPaper}
          handleSelectUser={handleSelectUser}
          handleSearchAgain={handleSearchAgain}
          handleClickClearIon={handleClearIcon}
          handleClickSelectSaveUser={() => () => null}
          isShowCustomPaper={false}
          showText={!requestUser && !isArtistSelectedFromArtwork}
          disabled={isArtistSelectedFromArtwork}
        />
      </div>
    </Section>
  );
};

export default SelectUserCustomRequestCer;
